// extracted by mini-css-extract-plugin
export default {"container":"container___x_3Pl","operation-list":"operation-list___DMsVe","rightLabel":"rightLabel___iVQO8"};